import { render, staticRenderFns } from "./AssetDetailDialog.vue?vue&type=template&id=384b87c5&scoped=true&"
import script from "./AssetDetailDialog.vue?vue&type=script&lang=js&"
export * from "./AssetDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssetDetailDialog.vue?vue&type=style&index=0&id=384b87c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b87c5",
  null
  
)

export default component.exports